/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workingstudentchecked2Inputs */



/**

* @param {_Field_Workingstudentchecked2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_workingstudentchecked2 = /** @type {((inputs?: _Field_Workingstudentchecked2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workingstudentchecked2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Werksstudentenstatus überprüft")
});
export { _field_workingstudentchecked2 as "_field_workingStudentChecked" }